import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-mask"
}
const _hoisted_2 = { class: "modal-wrapper" }
const _hoisted_3 = { class: "modal-dialog modal-xl modal-dialog-scrollable" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "modal-header" }
const _hoisted_6 = { class: "modal-title" }
const _hoisted_7 = { class: "modal-body" }
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = { class: "error" }
const _hoisted_10 = { class: "form-group" }
const _hoisted_11 = { class: "error" }
const _hoisted_12 = {
  class: "row",
  style: {"margin-bottom":"5px"}
}
const _hoisted_13 = { class: "col-sm-3" }
const _hoisted_14 = ["onUpdate:modelValue"]
const _hoisted_15 = { class: "error" }
const _hoisted_16 = { class: "col-sm-2" }
const _hoisted_17 = ["onUpdate:modelValue"]
const _hoisted_18 = { class: "error" }
const _hoisted_19 = { class: "col-sm-6" }
const _hoisted_20 = ["onUpdate:modelValue"]
const _hoisted_21 = { class: "col-sm-1" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { class: "error" }
const _hoisted_24 = { class: "modal-footer justify-content-between" }
const _hoisted_25 = { class: "dropdown dropup" }
const _hoisted_26 = {
  key: 0,
  type: "button",
  class: "btn btn-danger",
  "data-toggle": "dropdown"
}
const _hoisted_27 = {
  type: "submit",
  form: "discrete-scale-editor-form",
  class: "btn btn-primary"
}

import { computed } from 'vue'
    import { EditorState } from '@common/Common'
    import { DiscreteScaleLevelReadModel } from '@Scales/readmodels'
    import type { DiscreteScaleEditorViewModel } from '@Scales/Components/DiscreteScaleEditor'

    /* props */
    
export default /*@__PURE__*/_defineComponent({
  __name: 'DiscreteScaleEditor',
  props: {
    viewModel: {}
  },
  emits: ["create-scale", "update-scale", "delete-scale"],
  setup(__props: any, { emit: __emit }) {

    const props = __props

    /* emits */
    const emit = __emit

    /* shortcuts */
    const vm = computed(() => props.viewModel)

    /* derived state */
    const opened = computed(() => vm.value?.opened ?? false)

    const confirmButtonLabel = computed(() =>
        vm.value.state === EditorState.Creator ? 'Create' : 'Update'
    )

    const modalTitle = computed(() =>
        vm.value.state === EditorState.Creator ? 'Create scale' : 'Edit scale'
    )

    const canDelete = computed(() =>
        vm.value.state === EditorState.Editor
    )

    const nameError = computed(() => vm.value.nameError)
    const descriptionError = computed(() => vm.value.descriptionError)
    const levelsError = computed(() => vm.value.levelsError)

    const levels = computed(() => vm.value.levels)

    /* v-model proxies */

    const name = computed({
        get: () => vm.value.name,
        set: v => (vm.value.name = v)
    })

    const description = computed({
        get: () => vm.value.description,
        set: v => (vm.value.description = v)
    })

    /* actions */

    function removeScaleLevel(lvl: DiscreteScaleLevelReadModel)
    {
        vm.value.levels.splice(vm.value.levels.indexOf(lvl), 1)
    }

    function addScaleLevel()
    {
        vm.value.levels.push(new DiscreteScaleLevelReadModel())
    }

    function handleFormSubmit()
    {
        vm.value.clearValidationErrors()

        if (vm.value.state === EditorState.Creator)
        {
            emit('create-scale', name.value, description.value, JSON.stringify(levels.value))
        } else
        {
            emit(
                'update-scale',
                vm.value.scaleId,
                name.value,
                description.value,
                JSON.stringify(levels.value)
            )
        }
    }

    function handleDeleteScale()
    {
        emit('delete-scale', vm.value.scaleId)
    }

    function close()
    {
        vm.value.close()
    }

return (_ctx: any,_cache: any) => {
  return (opened.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("h5", _hoisted_6, _toDisplayString(modalTitle.value), 1 /* TEXT */),
                _createElementVNode("button", {
                  onClick: close,
                  type: "button",
                  class: "close"
                }, "×")
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("form", {
                  id: "discrete-scale-editor-form",
                  onSubmit: _withModifiers(handleFormSubmit, ["prevent"])
                }, [
                  _createElementVNode("div", _hoisted_8, [
                    _cache[2] || (_cache[2] = _createElementVNode("label", null, "Name:", -1 /* CACHED */)),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((name).value = $event)),
                      class: "form-control",
                      required: "",
                      minlength: "2",
                      maxlength: "100"
                    }, null, 512 /* NEED_PATCH */), [
                      [
                        _vModelText,
                        name.value,
                        void 0,
                        { trim: true }
                      ]
                    ]),
                    _createElementVNode("div", _hoisted_9, _toDisplayString(nameError.value), 1 /* TEXT */)
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _cache[3] || (_cache[3] = _createElementVNode("label", null, "Description:", -1 /* CACHED */)),
                    _withDirectives(_createElementVNode("textarea", {
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((description).value = $event)),
                      rows: "3",
                      class: "form-control"
                    }, null, 512 /* NEED_PATCH */), [
                      [
                        _vModelText,
                        description.value,
                        void 0,
                        { trim: true }
                      ]
                    ]),
                    _createElementVNode("div", _hoisted_11, _toDisplayString(descriptionError.value), 1 /* TEXT */)
                  ]),
                  _cache[4] || (_cache[4] = _createStaticVNode("<div class=\"row\" style=\"margin-bottom:5px;\"><div class=\"col-sm-3\"><label>Scale level <span class=\"text-danger\">*</span></label></div><div class=\"col-sm-2\"><label>Value <span class=\"text-danger\">*</span></label></div><div class=\"col-sm-6\"><label>Definition</label></div></div>", 1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(levels.value, (l) => {
                    return (_openBlock(), _createElementBlock("div", null, [
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            "onUpdate:modelValue": ($event: any) => ((l.Name) = $event),
                            class: "form-control",
                            placeholder: "Level",
                            required: "",
                            minlength: "2",
                            maxlength: "100"
                          }, null, 8 /* PROPS */, _hoisted_14), [
                            [
                              _vModelText,
                              l.Name,
                              void 0,
                              { trim: true }
                            ]
                          ]),
                          _createElementVNode("div", _hoisted_15, _toDisplayString(l.NameError), 1 /* TEXT */)
                        ]),
                        _createElementVNode("div", _hoisted_16, [
                          _withDirectives(_createElementVNode("input", {
                            type: "number",
                            "onUpdate:modelValue": ($event: any) => ((l.Value) = $event),
                            min: "0",
                            placeholder: "Number...",
                            class: "form-control",
                            required: ""
                          }, null, 8 /* PROPS */, _hoisted_17), [
                            [
                              _vModelText,
                              l.Value,
                              void 0,
                              { number: true }
                            ]
                          ]),
                          _createElementVNode("div", _hoisted_18, _toDisplayString(l.ValueError), 1 /* TEXT */)
                        ]),
                        _createElementVNode("div", _hoisted_19, [
                          _withDirectives(_createElementVNode("textarea", {
                            type: "text",
                            "onUpdate:modelValue": ($event: any) => ((l.Definition) = $event),
                            rows: "1",
                            class: "form-control",
                            placeholder: "Definition for level"
                          }, null, 8 /* PROPS */, _hoisted_20), [
                            [
                              _vModelText,
                              l.Definition,
                              void 0,
                              { trim: true }
                            ]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_21, [
                          _createElementVNode("a", {
                            onClick: ($event: any) => (removeScaleLevel(l)),
                            class: "pointer fa fa-times"
                          }, null, 8 /* PROPS */, _hoisted_22)
                        ])
                      ])
                    ]))
                  }), 256 /* UNKEYED_FRAGMENT */)),
                  _createElementVNode("div", _hoisted_23, _toDisplayString(levelsError.value), 1 /* TEXT */),
                  _createElementVNode("p", null, [
                    _createElementVNode("a", {
                      class: "text-primary",
                      onClick: addScaleLevel
                    }, "Add scale level")
                  ])
                ], 32 /* NEED_HYDRATION */)
              ]),
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, [
                  (canDelete.value)
                    ? (_openBlock(), _createElementBlock("button", _hoisted_26, " Delete "))
                    : _createCommentVNode("v-if", true),
                  _createElementVNode("div", {
                    class: "dropdown-menu",
                    style: {"padding":"10px"}
                  }, [
                    _createElementVNode("a", {
                      class: "dropdown-item",
                      onClick: handleDeleteScale
                    }, "Confirm"),
                    _cache[5] || (_cache[5] = _createElementVNode("a", { class: "dropdown-item" }, "Cancel", -1 /* CACHED */))
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("button", {
                    type: "button",
                    onClick: close,
                    class: "btn btn-outline-secondary mr-1"
                  }, "Cancel"),
                  _createElementVNode("button", _hoisted_27, _toDisplayString(confirmButtonLabel.value), 1 /* TEXT */)
                ])
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("v-if", true)
}
}

})